import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Series from '../Series';

var BoxPlotSeries = function (_Component) {
  _inherits(BoxPlotSeries, _Component);

  function BoxPlotSeries() {
    _classCallCheck(this, BoxPlotSeries);

    return _possibleConstructorReturn(this, (BoxPlotSeries.__proto__ || _Object$getPrototypeOf(BoxPlotSeries)).apply(this, arguments));
  }

  _createClass(BoxPlotSeries, [{
    key: 'render',
    value: function render() {
      return React.createElement(Series, _extends({}, this.props, { type: 'boxplot' }));
    }
  }]);

  return BoxPlotSeries;
}(Component);

export default BoxPlotSeries;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jsx-highcharts/dist/es/components/BoxPlotSeries/BoxPlotSeries.js
// module id = 854
// module chunks = 0